webpackJsonp([114276838955818],{

/***/ 109:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Paul D Kimbrel","subtitle":"Web Developer, Technical Architect, Sound Engineer"}}},"layoutContext":{}}

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(236);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(109);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        "footer",
	        null,
	        _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-12" },
	                    "Copyright ",
	                    new Date().getFullYear(),
	                    " By Paul Kimbrel"
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(27);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var metadata = _ref.metadata,
	        hero = _ref.hero,
	        heroPosition = _ref.heroPosition;
	
	    var heroStyle = {};
	
	    if (hero !== undefined) {
	        heroPosition = heroPosition ? heroPosition : "70%";
	        heroStyle = {
	            "background": "url('/images/hero/" + hero + "')",
	            "backgroundPosition": "center " + heroPosition,
	            "backgroundSize": "cover"
	        };
	    }
	
	    return _react2.default.createElement(
	        'header',
	        { className: 'bodyHeader', style: heroStyle },
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            hero ? _react2.default.createElement('meta', { property: 'og:image', content: "https://www.paulkimbrel.com/images/hero/" + hero }) : _react2.default.createElement('meta', { property: 'og:image', content: 'https://www.paulkimbrel.com/images/self-pk.jpg' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-3' },
	                    _react2.default.createElement(
	                        'a',
	                        { href: '/' },
	                        _react2.default.createElement('img', { className: 'profile-image img-circle', src: '/images/profile-pic.jpeg', alt: 'Paul Kimbrel' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-9 profile-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'profile' },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'title' },
	                            _react2.default.createElement(
	                                'a',
	                                { href: '/' },
	                                metadata.title
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'h2',
	                            { className: 'desciption' },
	                            metadata.subtitle
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            { className: 'global-social list-inline' },
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'https://www.twitter.com/pkimbrel', target: '_blank' },
	                                    _react2.default.createElement('i', { className: 'fa fa-twitter' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'http://instagram.com/pkimbrel', target: '_blank' },
	                                    _react2.default.createElement('i', { className: 'fa fa-instagram' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'https://www.linkedin.com/in/pkimbrel/', target: '_blank' },
	                                    _react2.default.createElement('i', { className: 'fa fa-linkedin-square' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'https://soundcloud.com/paul-kimbrel', target: '_blank' },
	                                    _react2.default.createElement('i', { className: 'fa fa-soundcloud' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'https://plus.google.com/114118871174996663491/posts', target: '_blank' },
	                                    _react2.default.createElement('i', { className: 'fa fa-google-plus-square' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'https://github.com/pkimbrel', target: '_blank' },
	                                    _react2.default.createElement('i', { className: 'fa fa-github' })
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(35);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var slug = _ref.slug;
	    return _react2.default.createElement(
	        'nav',
	        { className: 'navbar navbar-default navbar-static-top', role: 'navigation' },
	        _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	                'div',
	                { className: 'navbar-header' },
	                _react2.default.createElement(
	                    'button',
	                    { type: 'button', className: 'navbar-toggle collapsed', 'data-toggle': 'collapse', 'data-target': '.navbar-collapse' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'sr-only' },
	                        'Toggle navigation'
	                    ),
	                    _react2.default.createElement('span', { className: 'icon-bar' }),
	                    _react2.default.createElement('span', { className: 'icon-bar' }),
	                    _react2.default.createElement('span', { className: 'icon-bar' })
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'navbar-brand visible-xs-block' },
	                    'Navigate'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'navbar-collapse collapse' },
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'nav navbar-nav' },
	                    _react2.default.createElement(
	                        'li',
	                        { className: slug === "/" ? 'active' : '' },
	                        _react2.default.createElement(
	                            'a',
	                            { href: '/' },
	                            'Home'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        { className: slug.indexOf("/articles") === 0 ? 'active' : '' },
	                        _react2.default.createElement(
	                            'a',
	                            { href: '/articles/1' },
	                            'Articles'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        { className: slug.indexOf("/music") === 0 ? 'active' : '' },
	                        _react2.default.createElement(
	                            'a',
	                            { href: '/music' },
	                            'Music'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        { className: slug.indexOf("/photos") === 0 ? 'active' : '' },
	                        _react2.default.createElement(
	                            'a',
	                            { href: '/photos' },
	                            'Photos'
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(84);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _navigation = __webpack_require__(85);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _footer = __webpack_require__(83);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var location = _ref.location,
	      children = _ref.children,
	      data = _ref.data;
	
	  var hero = "techno-banner.jpg";
	  var heroPosition = undefined;
	  if (location.pathname.indexOf("/music") === 0) {
	    hero = "music.jpg";
	  } else if (location.pathname.indexOf("/photos") === 0) {
	    hero = "photos.jpg";
	    heroPosition = "35%";
	  }
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_header2.default, { metadata: data.site.siteMetadata, hero: hero, heroPosition: heroPosition }),
	    _react2.default.createElement(_navigation2.default, { slug: location.pathname }),
	    children(),
	    _react2.default.createElement(_footer2.default, null)
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-a96d6bc24c5ca1b798a1.js